import type { PriceUnitDto } from '@/api';
import { themeColors } from '@/theme/colors';
import { Dropdown } from '@lego/connect-components-react';
import { Flex, Text } from '@lego/klik-ui';

type AlternativePriceListSelectorProps = {
  priceLists: PriceUnitDto[];
  selectedPriceListId: number | null;
  onSelect: (priceListId: number | null) => void;
};

const AlternativePriceListSelector = ({
  priceLists,
  selectedPriceListId,
  onSelect,
}: AlternativePriceListSelectorProps) => {
  const selectedValue = selectedPriceListId?.toString() ?? '';

  return (
    <Flex alignItems="center" gap="8px">
      <Flex alignItems="center" gap="2px">
        <Text
          className="body-xs-medium"
          color={themeColors.content.default}
          whiteSpace="nowrap"
        >
          Alt. PL
        </Text>
        <Text
          className="body-xs-bold"
          color={themeColors.support.warning.default}
        >
          *
        </Text>
      </Flex>
      <div style={{ minWidth: '140px' }}>
        <Dropdown
          aria-label="Select alternative price list"
          placeholder="Select..."
          value={selectedValue ? [selectedValue] : []}
          onChange={(_event, value) => {
            onSelect(Number(value?.[0]?.value));
          }}
        >
          {priceLists.map((pl) => (
            <Dropdown.Option key={pl.id} value={pl.id.toString()}>
              {pl.name || `Price List ${pl.id}`}
            </Dropdown.Option>
          ))}
        </Dropdown>
      </div>
      {selectedPriceListId === null && (
        <Text
          className="body-xs-regular"
          color={themeColors.support.warning.default}
        >
          Required
        </Text>
      )}
    </Flex>
  );
};

export default AlternativePriceListSelector;
